export default __webpack_public_path__ + "static/media/PavenDo.89e66fbc.png";